<template>
  <div>
    <div class="row">
      <div class="col">
        <div class="card bg-white">
          <div class="card-header bg-gray-100">
            <p class="text-semibold no-margin">
              Usuários Backoffice | {{id}}
            </p>
            <div class="heading-elements">
              <i class="fas fa-long-arrow-alt-left position-left" @click="voltar()" style="cursor: pointer"></i>
            </div>
          </div>

          <div class="box-body">
            <div v-show="errorMessage != ''" class="alert alert-danger">{{ errorMessage }}</div>

            <div class="row">
              <div class="form-group col-12 col-md-6">
                <label for="nome">Nome <sup class="text-danger">* </sup></label>
                <input id="nome" v-model="registro.nome" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.nome }">
                <span v-show="errors.nome != null" class="help-inline">{{ errors.nome }}</span>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="idc_status">Status <sup class="text-danger">* </sup></label>
                <select id="idc_status" v-model="registro.idc_status" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.idc_status }">
                  <option value="1">Ativo</option>
                  <option value="2">Inativo</option>
                </select>
                <span v-show="errors.idc_status != null" class="help-inline">{{ errors.idc_status }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-6">
                <label for="cpf">CPF <sup class="text-danger">* </sup></label>
                <input id="cpf" v-model="registro.cpf" v-mask="'###.###.###-##'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.cpf }">
                <span v-show="errors.cpf != null" class="help-inline">{{ errors.cpf }}</span>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="telefone">Telefone <sup class="text-danger">* </sup></label>
                <input id="telefone" v-model="registro.telefone" v-mask="'(##) ####-#####'" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.telefone }">
                <span v-show="errors.telefone != null" class="help-inline">{{ errors.telefone }}</span>
              </div>
            </div>
            <div class="row">
              <div class="form-group col-12 col-md-6">
                <label for="email">E-mail <sup class="text-danger">* </sup></label>
                <input id="email" v-model="registro.email" type="text" class="form-control" v-bind:class="{ 'box-input-required': errors.email }">
                <span v-show="errors.email != null" class="help-inline">{{ errors.email }}</span>
              </div>
              <div class="form-group col-12 col-md-6">
                <label for="cd_perfil">Perfil <sup class="text-danger">* </sup></label>
                <select id="cd_perfil" v-model="registro.cd_perfil" style="width: auto" class="form-control" v-bind:class="{ 'box-input-required': errors.cd_perfil }">
                  <option value="1">ADMINISTRADOR</option>
                </select>
                <span v-show="errors.cd_perfil != null" class="help-inline">{{ errors.cd_perfil }}</span>
              </div>
            </div>
          </div>

        <div class="box-footer text-center">
          <div class="btn-group">
            <button type="button" id="cancelButton" class="btn btn-warning" @click="voltar()">Cancelar</button>
            <button type="button" id="gravarButton" class="btn btn-success" @click="gravar()">Gravar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import { isValidCpf } from '@brazilian-utils/validators'
import { validate as isEmail } from 'email-validator'
import UsuarioActions from '../../actions/UsuarioActions'

export default {
  name: 'editar',
  props: ['id'],
  data () {
    return {
      strongRegex: new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'),
      errorMessage: '',
      errors: {},
      hasError: false,
      registro: {
        nome: '',
        cpf: '',
        telefone: '',
        email: '',
        cd_perfil: '',
        cd_sistema: '',
        idc_status: '',
        status_desc: '',
        perfil: {
          nome: ''
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = 'Editar'

    UsuarioActions.obterUsuario(this.id)
      .then(res => {
        if (res && res.nome) {
          this.registro = res
        } else {
          this.errorMessage = 'Registro não encontrado.'
        }
      })
      .catch((error) => {
        console.log(error.message)
        this.errorMessage = 'Registro não encontrado.'
      })
  },
  methods: {
    voltar () {
      this.$router.push('/usuarios')
    },
    validation () {
      this.errors = {}
      this.hasError = false

      if (!this.registro.nome) {
        this.errors.nome = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.cpf) {
        this.errors.cpf = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (!isValidCpf(this.registro.cpf)) {
        this.errors.cpf = 'CPF inválido.'
        this.hasError = true
      }

      if (!this.registro.telefone) {
        this.errors.telefone = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.email) {
        this.errors.email = 'Este campo deve ser preenchido.'
        this.hasError = true
      } else if (!isEmail(this.registro.email)) {
        this.errors.email = 'E-mail inválido.'
        this.hasError = true
      }

      if (!this.registro.cd_perfil) {
        this.errors.cd_perfil = 'Este campo deve ser preenchido.'
        this.hasError = true
      }

      if (!this.registro.idc_status) {
        this.errors.idc_status = 'Este campo deve ser preenchido.'
        this.hasError = true
      }
    },

    gravar () {
      this.$parent.$parent.$data.showModalLoader = true

      this.validation()

      if (!this.hasError) {
        UsuarioActions.alterarUsuario({
          id: this.id,
          nome: this.registro.nome,
          cpf: this.registro.cpf,
          telefone: this.registro.telefone,
          email: this.registro.email,
          cd_perfil: this.registro.cd_perfil,
          idc_status: this.registro.idc_status,
          cd_sistema: 1
        }, this, '/usuarios')
      } else {
        this.$parent.$parent.$data.showModalLoader = false
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/usuarios/Editar.vue